import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { matchRoutes, useNavigate } from 'react-router-dom';
import {
  isSessionRefreshed,
  isRefreshRequired,
  isRefreshFailed,
  isSessionEnded,
} from '../../store/refreshSlice';
import { useAppDispatch } from '../../store/store';
import { executeLogout } from '../../store/logoutSlice';
import { TIMEOUT_TIMER_INTERVAL } from '../../utils/constants/timeoutConstants';

export const useToShowTimeoutPopup = () => {
  let timeoutCountdown: any = null;
  const [showTimeOutPrompt, setShowTimeOutPrompt] = useState(false);

  // variables for timeout popup
  const sessionRefreshed = useSelector(isSessionRefreshed);
  const sessionEnded = useSelector(isSessionEnded);
  const refreshRequired = useSelector(isRefreshRequired);
  const refreshFailed = useSelector(isRefreshFailed);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const isSessionTimeoutRoute = (currentRoute: string) => {
    const allowedRoutesForTimeout = [
      { path: '/welcome' },
      { path: '/dashboard' },
    ];
    const routesMatch = matchRoutes(allowedRoutesForTimeout, currentRoute);
    return !!routesMatch && routesMatch.length > 0;
  };

  useEffect(() => {
    if (!showTimeOutPrompt && isSessionTimeoutRoute(location.pathname)) {
      timeoutCountdown = setTimeout(() => {
        setShowTimeOutPrompt(true);
      }, TIMEOUT_TIMER_INTERVAL * 1000);
    } else if (!isSessionTimeoutRoute(location.pathname)) {
      clearTimeout(timeoutCountdown);
    }
    return () => {
      clearTimeout(timeoutCountdown);
    };
  }, [showTimeOutPrompt, location.pathname]);

  useEffect(() => {
    // refresh required when user click continue session
    if (refreshRequired) {
      //session refreshed when refresh api return success
      if (sessionRefreshed) {
        setShowTimeOutPrompt(false);
      }
      //session Ended when user has extended the session three times
      if (sessionEnded) {
        setShowTimeOutPrompt(false);
        dispatch(executeLogout());
        clearTimeout(timeoutCountdown);
        navigate('/session-timeout-error');
      }
      //session refresh failed when refresh api returns error
      if (refreshFailed) {
        setShowTimeOutPrompt(false);
        dispatch(executeLogout());
        navigate('/system-down');
      }
    }
  }, [refreshRequired, sessionRefreshed, refreshFailed]);

  return [showTimeOutPrompt, setShowTimeOutPrompt];
};
